import { createApplication } from '../../../universal/createApplication';
import { createMainStore } from './createMainStore';
import { createMainReducer } from './createMainReducer';
import { createMainRoutes } from './createMainRoutes';

export function createMainApplication(routerHOC, i18n, initialState, middlewares, experiments = {}, services, dataFetcher) {
  const reducer = createMainReducer();
  const store = createMainStore(true, 'Business Name Generator', initialState, reducer, middlewares);
  const routes = createMainRoutes();
  const component = createApplication(routerHOC, routes, store, i18n, services, dataFetcher, experiments);
  return { component, store };
}
